import bp from '@bbl-digital/snorre/lib/globals/styles/breakpoints'
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { IStyledProps } from '.'

export const Wrapper = styled.div(
  (props: IStyledProps) => css`
    display: grid;
    width: 100%;
    grid-row-gap: 1.5em;
    margin: ${props.my || 0}em ${props.mx || 0}em;
    margin-top: ${props.mt || 0}em;
    margin-bottom: ${props.mb || 0}em;
    grid-auto-flow: ${props.archiveFilter ? 'column' : 'row'};

    @media screen and (max-width: ${bp.large}) {
      grid-row-gap: 1em;
      align-items: flex-start;

      & > div {
        margin-left: 0;
        align-self: flex-end;
      }
    }

    @media screen and (max-width: ${bp.medium}) {
      & > div {
        margin-top: 0;
      }
    }
  `
)

export const InputWrapper = styled.div(
  (props: IStyledProps) => css`
    display: grid;
    grid-template-columns: ${props.hasFilter
      ? '1fr min-content min-content'
      : '1fr min-content'};
    width: 100%;
    gap: 0.5em;
    max-width: 410px;
    align-items: center;

    & > span {
      align-self: center;
    }

    @media screen and (max-width: ${bp.large}) {
      min-width: 100%;
    }
  `
)
